<template>
  <div v-if="section && section.blocks">
    <!-- Header -->
    <div class="ethics__header">
      <h1 class="alternative-page">
        <i class="signature">Shine On</i>
        <span v-if="showConduct" class="outline" style="--text:'Code Of Conduct'">Code Of Conduct</span>
        <span v-else class="outline" style="--text:'Ethics & Sustainability'">Ethics & Sustainability</span>
      </h1>
      <div
        class="rte"
        v-html="showConduct ? section.settings.code_of_conduct_summary : section.settings.ethics_summary">
      </div>
    </div>

    <template v-if="showConduct">
      <div class="ethics__content rte">
        <div v-html="section.settings.code_of_conduct"></div>
      </div>
    </template>

    <template v-else>
      <!-- Content -->
      <div class="ethics__content rte">
        <div v-html="contentFirst"></div>
        <TransitionExpand>
          <div
            v-show="readMore"
            v-html="contentRest">
          </div>
        </TransitionExpand>
        <button
          class="btn btn--center"
          v-text="readMore ? 'Read Less' : 'Read More'"
          @click="readMore = !readMore">
        </button>
      </div>

      <hr>

      <!-- Supplier Blocks -->
      <div class="ethics__supplier-blocks--wrapper">
        <header class="ethics__supplier-blocks-header">
          <h1>Our Suppliers On Sustainability</h1>
          <p>Please, click on the cards to learn more.</p>
        </header>
        <div class="ethics__supplier-blocks">
          <div
            class="supplier-block"
            :class="{ 'active': idx == activeSupplier }"
            v-for="(supplier, idx) in suppliers"
            @click="open(idx)"
            :key="supplier.id">
            <h5 class="supplier-block__label">{{ supplier.name }}</h5>
          </div>
        </div>
      </div>

      <!-- Supplier Modal -->
      <modal
        name="supplier"
        width="90%"
        height="85%"
        :maxWidth="850"
        :maxHeight="500"
        :adaptive="true"
        @before-close="activeSupplier = null">
        <div class="modal-person" v-if="suppliers[activeSupplier]">
          <button
            class="vm--close"
            @click="close()">
          </button>
          <div class="modal-person__left">
            <i class="signature">Ethics & Sustainability</i>
            <h1>{{ suppliers[activeSupplier].name }}</h1>
            <div v-html="suppliers[activeSupplier].content"></div>
          </div>
          <div class="modal-person__right" v-if="suppliers[activeSupplier].image.src">
            <VImg :media="suppliers[activeSupplier].image" />
            <p>
              <small>
                <a
                  class="btn--small"
                  :href="suppliers[activeSupplier].link"
                  :title="`Shop ${ suppliers[activeSupplier].name }`"
                  :aria-label="`Shop ${ suppliers[activeSupplier].name }`">
                  Shop {{ suppliers[activeSupplier].name }}
                </a>
              </small>
            </p>
          </div>
        </div>
      </modal>
    </template>

    <button
      class="conduct-toggle btn btn--secondary"
      v-text="showConduct ? 'Go Back' : 'Supplier Code Of Conduct'"
      @click="showConduct = !showConduct">
    </button>
  </div>
  <Loading
    v-else
    :activated="true"
  />
</template>



<script>
import VImg from './../components/VImg'
import TransitionExpand from './../transitions/TransitionExpand'
import Loading from './../components/Loading'

export default {
  name: 'Ethics',

  components: { VImg, TransitionExpand, Loading },

  props: [ 'page_content' ],

  computed: {
    contentFirst () {
      return this.section.settings.content.split('<br>').filter((p, idx) => idx < 2).join('')
    },
    contentRest () {
      return this.section.settings.content.split('<br>').filter((p, idx) => idx > 1).join('')
    },
    suppliers () {
      return this.section.blocks
    }
  },
  
  data () {
    return {
      section: null,
      readMore: false,
      activeSupplier: null,
      showConduct: false
    }
  },

  mounted () {
    this.loadSection()
  },

  methods: {
    loadSection () {
      fetch(`/collections/all?view=ethics`)
        .then(res => res.json()).then(data => {
          if (data.length) {
            this.section = JSON.parse(data)
          }
        })
    },
    open (idx) {
      this.activeSupplier = idx
      this.$modal.show('supplier')
    },
    close () {
      this.$modal.hide('supplier')
    }
  }
}
</script>
